export default __webpack_public_path__ + "_/images/landing-affiliates/wheel-3dac5e6c73d8e7c4fc25c16583fff7d923f9fbbe3caff2b2cd85b27ff09733e0.svg";